<template>
  <form>
    <div class="settings-top-bar" ref="optionsTopBar">
      <div class="top-bar">
       <p>
          <a class="btn btn-orange btn-icon" :title="$t('general.back')" @click.prevent="backButton"><i class="ti-arrow-left"></i></a>
       </p>
       <p class="d-inline-flex">
          <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="$route.params.id" @click.prevent="deleteOrderScreen" style="padding: 7px 10px; margin-right: 20px;">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <div class="row mar-to-15" style="display: flex; justify-content: flex-start; align-items: stretch;">
      <div class="col-lg-12 col-md-12">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div class="card-content">
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>ID</label>
                  <input type="number"
                    disabled
                    placeholder="ID"
                    v-model="model.id"
                    class="form-control">
                </div>

                <div class="form-group">
                  <label>Ip:Port</label>
                  <input type="text"
                    placeholder="192.168.100.100:65400"
                    v-validate="modelValidate.ip_port_printer"
                    v-model="model.ip_port_printer"
                    class="form-control">
                </div>

                <div class="form-group">
                  <label>Series</label>
                  <input type="text"
                    placeholder="series"
                    v-validate="modelValidate.series"
                    v-model="model.series"
                    class="form-control">
                </div>

                <div class="form-group">
                  <p-switch v-model="model.cash_register_auto_dp_before_z" type="success" ></p-switch>
                  <label> Emite automat dispozitie de plata la generarea raportului Z</label>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Serie Dispozitie De Plata*</label>
                      <input type="text"
                        placeholder="Serie Dispozitie De Plata"
                        v-validate="modelValidate.serie_dispozitie_plata"
                        v-model="model.serie_dispozitie_plata"
                        class="form-control">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Urmatorul Numar Dispozitie De Plata*</label>
                      <input type="number"
                        placeholder="Urmatorul Numar Dispozitie De Plata"
                        v-validate="modelValidate.numar_dispozitie_plata"
                        v-model="model.numar_dispozitie_plata"
                        class="form-control">
                    </div>
                  </div>
                </div>

                <div class="form-group mar-to-20">
                  <h4>Mapare TVA pentru imprimanta fiscală</h4>
                  <p class="help-block">Codul TVA este specific acestei imprimante și este rezolvat doar în momentul fiscalizării.</p>
                  <table class="table table-striped">
                    <thead><tr><th>TVA</th><th>vat_printer_id</th></tr></thead>
                    <tbody>
                      <tr v-for="mapping in model.vat_rates" :key="mapping.vat_rate_id">
                        <td>{{ mapping.rate }}% <span v-if="!mapping.is_active" class="text-muted">(inactiv, păstrat)</span></td>
                        <td><input v-model="mapping.vat_printer_id" type="text" class="form-control" placeholder="Cod TVA pe imprimantă"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import Vue from 'vue'
  // import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker, Select} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import BackgroundColorPicker from 'src/components/UIComponents/BackgroundColorPicker.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Select)

  export default {
    components: {
      PSwitch,
      BackgroundColorPicker,
      [Button.name]: Button,
      [Input.name]: Input,
      [Select.name]: Select
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      this.getVatRates()
      this.getData()
    },
    data () {
      return {
        id: this.value || this.tableId,
        locations: [],
        table_maps: [],
        model: {
          'id': 0,
          'type': 1,
          'ip_port_printer': null,
          'cash_register_auto_dp_before_z': null,
          'serie_dispozitie_plata': null,
          'numar_dispozitie_plata': null,
          'vat_rates': []
        },
        modelValidate: {
          ip_port_printer: {required: true},
          series: {required: false},
          serie_dispozitie_plata: {required: true},
          numar_dispozitie_plata: {required: true}
        },
        loading: true,
        vatOptions: [],
        vatOptionsLoaded: false,
        printerLoaded: false,
        printerVatMappings: [],
        colors: {
          defult: '#c850c0',
          black: '#000'
        }
      }
    },
    methods: {
      copyToClipboard (textToCopy) {
        textToCopy = textToCopy.replace(/\s/g, '')
        this.$copyText(textToCopy)
      },
      getData () {
        var id = this.id || this.route.params.id
        if (id) {
          let data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }
          this.apiRequest('/fiscal-printer/' + id, 'GET', data, (response) => {
            if (response.status) {
              this.model = response.data.fiscalPrinter
              this.printerVatMappings = (this.model.vat_rates || []).slice()
              if (this.model.location_id) {
                this.changeLocation(true)
              }
            }
            this.printerLoaded = true
            this.mergeVatMappings()
            this.loading = false
          })
        } else {
          this.printerLoaded = true
          this.mergeVatMappings()
          this.loading = false
        }
      },
      getVatRates () {
        this.apiRequest('/taxes-v2/vat-rates', 'GET', {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }, (response) => {
          if (response.status) {
            this.vatOptions = response.data || []
            this.vatOptionsLoaded = true
            this.mergeVatMappings()
          }
        })
      },
      mergeVatMappings () {
        if (!this.model || !this.vatOptionsLoaded || !this.printerLoaded) return
        const existing = {}
        ;(this.printerVatMappings || []).forEach(mapping => {
          existing[String(mapping.vat_rate_id)] = mapping
        })
        const rows = (this.vatOptions || []).map(vat => ({
          vat_rate_id: vat.id,
          rate: vat.rate,
          is_active: vat.is_active,
          vat_printer_id: existing[String(vat.id)] ? existing[String(vat.id)].vat_printer_id : ''
        }))
        this.$set(this.model, 'vat_rates', rows)
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          const companyData = this.$session.get('selectedCompanyData') || {}
          const missingVatMapping = (this.model.vat_rates || []).some(mapping => !mapping.vat_printer_id || Number(mapping.vat_printer_id) <= 0)
          if (Number(companyData.taxes_version) === 2 && missingVatMapping) {
            swal({text: 'Toate cotele TVA trebuie mapate pe imprimanta fiscală.', type: 'error'})
            return
          }
          if (isValid) { this.saveTable() }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            if (errors[prop].length === 1) {
              this.errors.add(prop, errors[prop][0])
            } else {
              this.errors.add(prop, errors[prop])
            }
          } else {
            this.errors.add('error', errors[prop])
          }
        }
      },
      saveTable () {
        this.loading = true

        let data = {
          ...this.model,
          'token': this.$session.get('token'),
          'company_id': this.$session.get('selectedCompany')
        }

        var id = this.id || this.route.params.id
        let url = ''
        let request = ''
        if (id) {
          url = '/fiscal-printer/' + id
          request = 'PUT'
        } else {
          url = '/fiscal-printer/add'
          request = 'POST'
        }
        this.apiRequest(url, request, data, (response) => {
          if (response.status === true) {
            this.errors.clear()
            if (request === 'POST') {
              this.$bus.$emit('refresh')
              this.$bus.$emit('close-modal')
              // this.router.push('/fiscal-printer/edit/' + response.data.fiscalPrinter.id)
            } else {
              this.backButton()
            }
            swal(
              {
                title: '',
                text: this.$t('settingTable.tableSave'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }
            )
          } else {
            this.handleErrors(response.errors)
          }
          this.loading = false
        })
      },
      deleteOrderScreen () {
        this.loadingReset = true
        var id = this.id || this.route.params.id
        var data = {
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token'),
          delete: true
        }
        this.apiRequest('/fiscal-printer/' + id, 'DELETE', data, (response) => {
          if (response.status) {
            swal({'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
            this.backButton()
          } else {
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          }
          this.loadingReset = false
        })
      },
      changeLocation (doNotEmptyModel = false) {
        if (!doNotEmptyModel) {
          this.model.table_maps_ids = []
        }
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_id: this.model.location_id
        }
        this.loading = true
        this.apiRequest('/pos/all/map', 'GET', data, (response) => {
          if (response.status) {
            this.table_maps = response.data.fiscalPrinter
          }
          this.loading = false
        })
      },
      backButton () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
        // this.router.push('/pos/tabs?tabIndex=5')
      },
      updateColor (value) {
        this.model.background_color = value
      }
    }
  }
</script>
<style scoped lang="scss">
  .copy_link {
    margin-top: 10px;
    width: 100%;
  }
  .upload-demo input[type="file"]{ display: none; }
  .middle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>
<style>
  span.el-select__tags-text {
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/fiscalPrinter/FiscalPrinterForm.vue